<template>
  <div class="logo-container">
    <div class="logo">
      <!-- <img :src="logo" alt  /> -->
      <el-image
        :src="logo"
        :title="mallName"
        @click="goHome"
        fit="contain"
      ></el-image>
      <div class="logoInfo">
        <span class="title">{{ title }}</span>
        <span v-if="(pronFlag==true?true:false)&&(moduleDistribution ==1?true:false)&&(pron != ''?true:false)" class="pron">邀请码：{{ pron }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getXBBasicInformation, getXBPron } from "common/js/storage";
export default {
  props: {
    title: String,
  },
  data() {
    return {
      logo: "",
      mallName: "",
      pron: "",
      pronFlag: false,
      moduleDistribution: ""
    };
  },
  beforeMount() {
    if(getXBPron()) {
      this.pron = getXBPron()
    }
    this.moduleDistribution = getXBBasicInformation().moduleInvitation
    this.pronFlag = window.location.pathname.split('/')[1] == 'personal'?true:false
    this.basicInformation();
  },
  methods: {
    goHome() {
      this.$router.push("/homepage");
    },
    // 获取基础信息
    basicInformation() {
      if (getXBBasicInformation() === "") {
        setTimeout(() => {
          let res = getXBBasicInformation();
          this.background = `backgroundImage: url(${res.loginImage});`;
          this.logo = res.logo;
        }, 800);
      } else {
        let res = getXBBasicInformation();
        this.background = `backgroundImage: url(${res.loginImage});`;
        this.logo = res.logo;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.logo-container {
  background: #fff;
  margin-bottom: 20px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  .logo {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    height: 80px;
    background: #fff;
    padding: 10px 0 10px 20px;
    display: flex;
    align-items: flex-end;
    .el-image {
      width: 150px;
      height: 60px;
      margin-right: 25px;
      cursor: pointer;
    }
    .logoInfo {
      width: 85%;
      display: flex;
      justify-content: space-between;
    }
    .title {
      font-size: 24px;
      color: rgba(96, 98, 102, 1);
      line-height: 33px;
      letter-spacing: 2px;
      padding-bottom: 5px;
    }
    .pron {
      font-size: 20px;
      font-weight: bold;
      color: #606266;
      line-height: 38px;
    }
  }
}
</style>
